export const SET_COUNTRIES = 'COUNTRIES/SET_COUNTRIES' 
export const SORT_COUNTRIES = 'COUNTRIES/SORT_COUNTRIES' 